import { useEffect, useState } from "react";

//components
import { Grid } from "@mui/material";
import LoginPanel from "./Login";
import Navigator from "./Navigator";
import Timelines from "./Timelines";
import SignupPanel from "./Signup";
import Divine from "./Divine";
import Goto from "./Goto";
import Search from "./Search"

//icons
import HomeIcon from "@mui/icons-material/Home";
import PersonAddIcon from "@mui/icons-material/PersonAdd";

function RightPanel(props) {
  const {
    frequency,
    password,
    passwordRepeat,
    referralCode,
    searchQuery,
    currentTypingFocus,
    setCurrentTypingFocus,
    setActiveTab,
    resetInputValues,
  } = props;
  const [blinkingCursor, setBlinkingCursor] = useState(false);
  const [rightState, setRightState] = useState("navigator");

  useEffect(() => {
    const blinkingCursorInterval = setInterval(() => {
      setBlinkingCursor((current) => !current);
    }, 500);

    return () => {
      clearInterval(blinkingCursorInterval);
    };
  }, []);

  return (
    <>
      <Grid
        container
        columns={24}
        style={{
          width: "100%",
          height: "100%",
          marginLeft: "0",
          paddingRight: "2%",
        }}
      >
        <Grid item xs={21} style={{ height: "100%", overflow: "hidden" }}>
          {rightState === "login" && (
            <LoginPanel
              frequency={frequency}
              password={password}
              currentTypingFocus={currentTypingFocus}
              setRightState={setRightState}
              setCurrentTypingFocus={setCurrentTypingFocus}
              resetInputValues={resetInputValues}
            />
          )}
          {rightState === "signup" && (
            <SignupPanel
              frequency={frequency}
              password={password}
              passwordRepeat={passwordRepeat}
              referralCode={referralCode}
              currentTypingFocus={currentTypingFocus}
              setRightState={setRightState}
              setCurrentTypingFocus={setCurrentTypingFocus}
              resetInputValues={resetInputValues}
            />
          )}
          {rightState === "navigator" && (
            <Navigator setRightState={setRightState} />
          )}
          {rightState === "timelines" && (
            <Timelines
              setActiveTab={setActiveTab}
              band={"original"}
              setRightState={setRightState}
            />
          )}
          {rightState === "divine" && <Divine setRightState={setRightState} />}
          {rightState === "goto" && (
            <Goto
              setActiveTab={setActiveTab}
              band={"original"}
              setRightState={setRightState}
              frequency={frequency}
              currentTypingFocus={currentTypingFocus}
              setCurrentTypingFocus={setCurrentTypingFocus}
              resetInputValues={resetInputValues}
            />
          )}
          {rightState === "search" && (
            <Search
              setActiveTab={setActiveTab}
              band={"original"}
              setRightState={setRightState}
              searchQuery={searchQuery}
              currentTypingFocus={currentTypingFocus}
              setCurrentTypingFocus={setCurrentTypingFocus}
              resetInputValues={resetInputValues}
            />
          )}
        </Grid>
        <div
          item
          xs={3}
          style={{
            // backgroundColor: "#ffffff50",
            borderLeft: "1.5px solid rgb(0, 255, 0)",
            maxHeight: "100%",
          }}
        >
          <div
            style={{
              height: "50%",
              color: rightState === "navigator" ? "#004400" : "#55ff55",
              borderBottom: "1.5px solid rgb(0, 255, 0)",
              display: "grid",
              alignItems: "center",
              justifyContent: "center",
              paddingLeft: "10%",
            }}
            onClick={() => {
              setRightState("navigator");
            }}
          >
            <HomeIcon fontSize="large"></HomeIcon>
          </div>
          <div
            style={{
              height: "50%",
              color: "#55ff55",
              display: "grid",
              alignItems: "center",
              justifyContent: "center",
              paddingLeft: "10%",
            }}
            onClick={() => {
              setRightState("signup");
            }}
          >
            <PersonAddIcon fontSize="large"></PersonAddIcon>
          </div>
        </div>
      </Grid>
    </>
  );
}

export default RightPanel;
